import { injectable } from 'inversify';
import { VersionGame } from '@Models';
import { version_games } from '@Api';

@injectable()
export class VersionGameMapper {
  public map(item: version_games): VersionGame {
    switch (item) {
      case version_games.ESSENCE_OF_WAR:
        return VersionGame.EssenceOfWar;
      case version_games.BATTLE:
        return VersionGame.WarhammerBattle;
      case version_games.THE_OLD_WORLD:
        return VersionGame.TheOldWorld;
    }
    return VersionGame.NinthAge;
  }
}
